// DISCIPLAYGROUND — blog page behaviors. Defensive: every block guarded so one failure doesn't kill the rest.

(function () {
  // SHARED dropdown drawer — desktop opens on hover (TOPICS / SUBSCRIBE), mobile opens via hamburger and switches modes via mobile-menu items.
  try {
    const drawer = document.getElementById('dropdownDrawer');
    const topicsBtn = document.getElementById('topicsBtn');
    const subscribeBtn = document.getElementById('subscribeBtn');
    const hamburgerBtn = document.getElementById('hamburgerBtn');
    const closeBtn = document.getElementById('dropdownCloseBtn');
    if (!drawer) return;
    let drawerCloseTimer = null;
    const isMobile = () => window.matchMedia('(max-width: 720px)').matches;
    function openDrawer(mode) {
      if (drawerCloseTimer) { clearTimeout(drawerCloseTimer); drawerCloseTimer = null; }
      drawer.dataset.mode = mode;
      drawer.classList.add('is-open');
      if (hamburgerBtn) hamburgerBtn.setAttribute('aria-expanded', 'true');
    }
    function closeDrawer() {
      drawer.classList.remove('is-open');
      if (hamburgerBtn) hamburgerBtn.setAttribute('aria-expanded', 'false');
    }
    function closeDrawerSoon() {
      if (drawerCloseTimer) clearTimeout(drawerCloseTimer);
      drawerCloseTimer = setTimeout(closeDrawer, 200);
    }
    // ----- Desktop hover -----
    if (topicsBtn) {
      topicsBtn.addEventListener('mouseenter', () => { if (!isMobile()) openDrawer('topics'); });
      topicsBtn.addEventListener('mouseleave', () => { if (!isMobile()) closeDrawerSoon(); });
      topicsBtn.addEventListener('click', (e) => { e.preventDefault(); openDrawer('topics'); });
    }
    if (subscribeBtn) {
      subscribeBtn.addEventListener('mouseenter', () => { if (!isMobile()) openDrawer('subscribe'); });
      subscribeBtn.addEventListener('mouseleave', () => { if (!isMobile()) closeDrawerSoon(); });
      subscribeBtn.addEventListener('click', (e) => { e.preventDefault(); openDrawer('subscribe'); });
    }
    drawer.addEventListener('mouseenter', () => {
      if (drawerCloseTimer) { clearTimeout(drawerCloseTimer); drawerCloseTimer = null; }
    });
    drawer.addEventListener('mouseleave', () => { if (!isMobile()) closeDrawerSoon(); });
    // ----- Mobile hamburger -----
    if (hamburgerBtn) {
      hamburgerBtn.addEventListener('click', (e) => {
        e.preventDefault();
        if (drawer.classList.contains('is-open')) closeDrawer();
        else openDrawer('menu');
      });
    }
    // Mobile menu items + back button — switch the drawer mode in place
    drawer.querySelectorAll('[data-go]').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        openDrawer(btn.dataset.go);
      });
    });
    // Close button + ESC
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeDrawer(); });
    // Tap outside drawer (on dimmed area) — close on mobile
    drawer.addEventListener('click', (e) => {
      if (e.target === drawer && isMobile()) closeDrawer();
    });
  } catch (e) { console.warn('dpg drawer:', e); }
})();

(function () {
  // scroll state — toggle body class once user passes hero
  try {
    let scrolledPast = null;
    function updateScrollState() {
      // Article pages frost the topbar after a tiny scroll so body copy on the
      // right column doesn't bleed through the masthead — index pages wait for
      // the hero pass since the hero itself is dark and self-contained.
      const isArticle = document.body.dataset.page === 'article';
      const threshold = isArticle ? 60 : window.innerHeight * 0.85;
      const isPast = window.scrollY > threshold;
      if (isPast !== scrolledPast) {
        document.body.classList.toggle('scrolled-past-hero', isPast);
        scrolledPast = isPast;
      }
    }
    window.addEventListener('scroll', updateScrollState, { passive: true });
    updateScrollState();
  } catch (e) { console.warn('dpg scroll-state:', e); }
})();

(function () {
  // Hero article copy appears right as the oversized publication wordmark hands
  // off to the top-left masthead, then rides the sticky photo for a short beat.
  try {
    const heroStage = document.querySelector('.hero-stage');
    const heroCopy = document.querySelector('[data-hero-copy]');
    if (!heroStage || !heroCopy) return;

    let ticking = false;
    let visible = null;

    function updateHeroCopy() {
      const vh = window.innerHeight || 1;
      const rect = heroStage.getBoundingClientRect();
      const localScroll = Math.max(0, -rect.top);
      const shouldShow = localScroll >= vh * 0.52 && rect.bottom > vh * 0.08;

      if (shouldShow !== visible) {
        heroCopy.classList.toggle('is-visible', shouldShow);
        visible = shouldShow;
      }
      ticking = false;
    }

    function requestHeroCopyUpdate() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(updateHeroCopy);
    }

    window.addEventListener('scroll', requestHeroCopyUpdate, { passive: true });
    window.addEventListener('resize', requestHeroCopyUpdate, { passive: true });
    updateHeroCopy();
  } catch (e) { console.warn('dpg hero-copy:', e); }
})();

(function () {
  // reading progress — drives every [data-progress-fill] (rail bar on desktop + mobile fixed top bar)
  try {
    const fills = document.querySelectorAll('[data-progress-fill]');
    const articleBody = document.querySelector('.article-body');
    if (fills.length && articleBody) {
      function updateProgress() {
        const rect = articleBody.getBoundingClientRect();
        const vh = window.innerHeight;
        const bodyH = articleBody.offsetHeight;
        const scrolled = Math.max(0, -rect.top + vh * 0.3);
        const total = bodyH - vh * 0.4;
        const pct = Math.max(0, Math.min(100, (scrolled / total) * 100));
        const w = pct + '%';
        fills.forEach(f => { f.style.width = w; });
      }
      window.addEventListener('scroll', updateProgress, { passive: true });
      updateProgress();
    }
  } catch (e) { console.warn('dpg progress:', e); }
})();

(function () {
  // RAIL FLOOD driver — replaces the old fog. The flood is the second half of
  // a two-stage progress story: (1) reading progress bar fills with --accent
  // (handled by the existing [data-progress-fill] driver) during body scroll,
  // (2) THIS driver rapidly fills the entire left col with --accent once the
  // user crosses .article-end — i.e., "topping off the tank" after the gauge
  // hits 100%. Range is tight (~0.6vh of scroll) so it feels like a quick
  // pour, not a slow rise.
  try {
    const stage = document.querySelector('.article-stage');
    const anchor = document.querySelector('.article-end') || document.querySelector('.article-body');
    if (stage && anchor) {
      function updateFlood() {
        const rect = anchor.getBoundingClientRect();
        const vh = window.innerHeight;
        // Start flooding when .article-end's top reaches 0.55vh from the viewport top (i.e., just below the fold of the body);
        // complete when its top reaches the upper-third position. ~0.22vh of scroll = rapid pour.
        const startY = vh * 0.55;
        const endY   = vh * 0.33;
        const progress = (startY - rect.top) / (startY - endY);
        const rise = Math.max(0, Math.min(1, progress));
        stage.style.setProperty('--flood-rise', rise.toFixed(3));
      }
      window.addEventListener('scroll', updateFlood, { passive: true });
      window.addEventListener('resize', updateFlood, { passive: true });
      updateFlood();
    }
  } catch (e) { console.warn('dpg flood:', e); }
})();

(function () {
  // Maude-style article split: the left column is sticky. Scroll hides the
  // title and reveals the cover; reaching the end of the right column hides the
  // cover and slides in the product rail.
  try {
    const articleImage = document.querySelector('.article-split .article-image');
    const articleMain = document.querySelector('.article-split .article-main');
    const articleEnd = document.querySelector('.article-split .article-end');
    if (!articleImage || !articleMain) return;

    function updateSplitArticle() {
      const scrollPosition = window.scrollY || window.pageYOffset || 0;
      const productAnchor = articleEnd || articleMain;
      const anchorRect = productAnchor.getBoundingClientRect();
      const viewportH = window.innerHeight;
      // Fire when end-of-dispatch enters the lower viewport — by then the user
      // is on the final few paragraphs and the product rail should be sliding in.
      const reachedEnd = articleEnd
        ? anchorRect.top < viewportH * 0.7
        : anchorRect.bottom < viewportH * 0.98;
      // Short-article guard: even if articleEnd is already in view on first
      // paint, never reveal the product rail until the user has scrolled.
      const trigger = scrollPosition > 0 && reachedEnd;
      articleImage.classList.toggle('show-image', scrollPosition > 0);
      articleImage.classList.toggle('show-footer', trigger);
    }

    window.addEventListener('scroll', updateSplitArticle, { passive: true });
    window.addEventListener('resize', updateSplitArticle, { passive: true });
    updateSplitArticle();
  } catch (e) { console.warn('dpg split article:', e); }
})();

(function () {
  // ROW-2 FLY-IN — Maude pattern. One-shot IntersectionObserver: when the
  // .article-products / .article-related cell first scrolls into view, add
  // .is-in. The CSS transition (cubic-bezier(0.52,0.15,0.63,1), 1s + 0.6s,
  // staggered delays) takes over from there. Time-based, not scroll-tied.
  try {
    const cells = document.querySelectorAll('.article-stage > .article-products, .article-stage > .article-related');
    if (!cells.length) return;
    if (!('IntersectionObserver' in window)) {
      document.documentElement.classList.add('dpg-row2-fallback');
      return;
    }
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) {
          e.target.classList.add('is-in');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    cells.forEach((c) => io.observe(c));
    // fail-safe: if cells weren't tagged after 2.5s (prerender, no-scroll readers, observer edge cases), force-reveal
    setTimeout(() => {
      const stuck = document.querySelectorAll('.article-stage > .article-products:not(.is-in), .article-stage > .article-related:not(.is-in)');
      if (stuck.length) document.documentElement.classList.add('dpg-row2-fallback');
    }, 2500);
  } catch (e) { console.warn('dpg row2 flyin:', e); }
})();

(function () {
  // title word stagger
  try {
    document.querySelectorAll('[data-stagger]').forEach(el => {
      const words = el.textContent.split(/\s+/);
      el.textContent = '';
      words.forEach((word, i) => {
        const span = document.createElement('span');
        span.textContent = word;
        span.style.transitionDelay = (i * 90) + 'ms';
        el.appendChild(span);
        if (i < words.length - 1) el.appendChild(document.createTextNode(' '));
      });
    });
  } catch (e) { console.warn('dpg stagger:', e); }
})();

(function () {
  // scroll reveal — add BOTH `.in` (my CSS) and `.visible` (theme.css convention)
  try {
    const io = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          e.target.classList.add('in');
          e.target.classList.add('visible');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    document.querySelectorAll('.reveal, .cover-anim, .title-stagger, .quote-words, .title-mask-reveal, .mini-card').forEach(el => io.observe(el));

    // fail-safe: reveal anything still hidden after 2.5s
    setTimeout(() => {
      document.querySelectorAll('.reveal:not(.in), .cover-anim:not(.in), .title-stagger:not(.in), .quote-words:not(.in), .title-mask-reveal:not(.in), .mini-card:not(.in)')
        .forEach(el => { el.classList.add('in'); el.classList.add('visible'); });
    }, 2500);
  } catch (e) { console.warn('dpg reveal:', e); }
})();


(function () {
  // infinite scroll — when .load-more-zone enters viewport, fetch next page and append mini-cards
  try {
    const grid = document.querySelector('[data-more-grid]');
    let zone = document.querySelector('.load-more-zone');
    if (!grid || !zone) return;
    let isLoading = false;
    const io = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting && !isLoading && zone && zone.dataset.nextUrl) {
          fetchNext();
        }
      });
    }, { rootMargin: '400px' });
    io.observe(zone);

    function fetchNext() {
      isLoading = true;
      zone.classList.add('is-loading');
      const url = zone.dataset.nextUrl;
      fetch(url, { headers: { Accept: 'text/html' } })
        .then(r => r.text())
        .then(html => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const newGrid = doc.querySelector('[data-more-grid]');
          const newZone = doc.querySelector('.load-more-zone');
          if (newGrid) {
            Array.from(newGrid.children).forEach(c => {
              c.classList.add('in', 'visible');
              grid.appendChild(c);
            });
          }
          io.unobserve(zone);
          if (newZone && newZone.dataset.nextUrl) {
            const link = zone.querySelector('.load-more-link');
            const newLink = newZone.querySelector('.load-more-link');
            zone.dataset.nextUrl = newZone.dataset.nextUrl;
            if (link && newLink) {
              link.href = newLink.href;
              link.textContent = newLink.textContent;
            }
            zone.classList.remove('is-loading');
            isLoading = false;
            io.observe(zone);
          } else {
            zone.remove();
          }
        })
        .catch((err) => {
          console.warn('dpg infinite-scroll:', err);
          zone.classList.remove('is-loading');
          isLoading = false;
        });
    }
  } catch (e) { console.warn('dpg infinite:', e); }
})();

/* ============================================================
   NEWSLETTER FORMS — inline success swap (no page reload).
   Targets form.js-newsletter on blog header drawer, blog grid
   bottom band, and article-body inline newsletter. Posts via
   fetch, then replaces the form with a success message in-place.
   ============================================================ */
(function () {
  var SUCCESS_COPY = 'Thanks for joining. Check your email to confirm.';
  function buildSuccess(form) {
    var msg = document.createElement('div');
    msg.className = 'newsletter-success';
    msg.setAttribute('role', 'status');
    msg.textContent = SUCCESS_COPY;
    if (form.classList.contains('subscribe-form'))                  msg.classList.add('newsletter-success--drawer');
    if (form.classList.contains('spread--newsletter__form'))        msg.classList.add('newsletter-success--band');
    if (form.classList.contains('article-newsletter-inline__form')) msg.classList.add('newsletter-success--inline');
    return msg;
  }
  function bind(form) {
    if (form.dataset.newsletterBound === '1') return;
    form.dataset.newsletterBound = '1';
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('button[type="submit"]');
      var originalText = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = '...'; }
      var data = new FormData(form);
      fetch(form.action, {
        method: 'POST',
        body: data,
        credentials: 'same-origin',
        headers: { 'Accept': 'text/html' }
      }).then(function () {
        form.replaceWith(buildSuccess(form));
      }).catch(function (err) {
        console.warn('dpg newsletter:', err);
        if (btn) { btn.disabled = false; btn.textContent = originalText; }
        /* on hard network failure show success anyway so the user gets feedback;
           the request usually reached Shopify even when fetch reports an error */
        form.replaceWith(buildSuccess(form));
      });
    });
  }
  function bindAll() {
    document.querySelectorAll('form.js-newsletter').forEach(bind);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindAll);
  } else {
    bindAll();
  }
})();
